import { Monedas, SiyNoString, YeminusApis } from "@cf-v5-workspace/enums";
import { MensajeAdvertencia, MensajeError } from "@cf-v5-workspace/messages";
import { TranslateService } from '@ngx-translate/core';
import ResponseModel from "../models/response.model";

declare var $: any;

/**
 * Método que se encarga de retornar la dirección del Api solicitada
 * @param apiConectar 
 * @author Bvelez
 */
export function obtenerBaseUrl(baseUrl: string, apiConectar: YeminusApis, devMode: boolean): string {
	var cadenaUrl = '';
	try {
		var urlBase = ObtenerRaizUrl(baseUrl);



		switch (apiConectar) {
			case YeminusApis.Admin:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Admin.Api/' : 'https://localhost:7172/';
				break;

			case YeminusApis.ActivosFijos:
				cadenaUrl = (!devMode) ? urlBase.origin + '/ActivosFijos.Api/' : 'https://localhost:7001/';
				break;
			case YeminusApis.CajasMenores:
				cadenaUrl = (!devMode) ? urlBase.origin + '/CajasMenores.Api/' : 'https://localhost:7261/';
				break;
			case YeminusApis.ComprasInventarios:
				cadenaUrl = (!devMode) ? urlBase.origin + '/ComprasInventarios.Api/' : 'https://localhost:7061/';
				break;
			case YeminusApis.ConsultasSql:
				cadenaUrl = (!devMode) ? urlBase.origin + '/ConsultasSql.Api/' : 'https://localhost:7248/';
				break;
			case YeminusApis.CuentasPorCobrar:
				cadenaUrl = (!devMode) ? urlBase.origin + '/CuentasPorCobrar.Api/' : 'https://localhost:7179/';
				break;
			case YeminusApis.CuentasPorPagar:
				cadenaUrl = (!devMode) ? urlBase.origin + '/CuentasPorPagar.Api/' : 'https://localhost:7012/';
				break;
			case YeminusApis.DocumentosElectronicos:
				cadenaUrl = (!devMode) ? urlBase.origin + '/DocumentosElectronicos.Api/' : 'https://localhost:7054/';
				break;
			case YeminusApis.Encuestas:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Encuestas.Api/' : 'https://localhost:7141/';
				break;
			case YeminusApis.EntregaMasivaDocumentos:
				cadenaUrl = (!devMode) ? urlBase.origin + '/EntregaMasivaDocumentos.Api/' : 'https://localhost:7246/';
				break;
			case YeminusApis.FacturacionPeriodica:
				cadenaUrl = (!devMode) ? urlBase.origin + '/FacturacionPeriodica.Api/' : 'https://localhost:7243/';
				break;
			case YeminusApis.Financiero:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Financiero.Api/' : 'https://localhost:7165/';
				break;
			case YeminusApis.GestionCapitalHumano:
				cadenaUrl = (!devMode) ? urlBase.origin + '/GestionCapitalHumano.Api/' : 'https://localhost:7100/';
				break;
			case YeminusApis.GestionContenidos:
				cadenaUrl = (!devMode) ? urlBase.origin + '/GestionContenidos.Api/' : 'https://localhost:7183/';
				break;
			case YeminusApis.GestionTrabajo:
				cadenaUrl = (!devMode) ? urlBase.origin + '/GestionTrabajo.Api/' : 'https://localhost:7217/';
				break;
			case YeminusApis.Importaciones:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Importaciones.Api/' : 'https://localhost:7127/';
				break;
			case YeminusApis.informesComerciales:
				cadenaUrl = (!devMode) ? urlBase.origin + '/InformesComerciales.Api/' : 'https://localhost:7031/';
				break;
			case YeminusApis.InformesFinancieros:
				cadenaUrl = (!devMode) ? urlBase.origin + '/InformesFinancieros.Api/' : 'https://localhost:7198/';
				break;
			case YeminusApis.Interfaces:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Interfaces.Api/' : 'https://localhost:7003/';
				break;
			case YeminusApis.Licenciamiento:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Licenciamiento.Api/' : 'https://localhost:7072/';
				break;
			case YeminusApis.Logistica:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Logistica.Api/' : 'https://localhost:7239/';
				break;
			case YeminusApis.MantenimientoMaquinaria:
				cadenaUrl = (!devMode) ? urlBase.origin + '/MantenimientoMaquinaria.Api/' : 'https://localhost:7052/';
				break;
			case YeminusApis.PresupuestoPrivado:
				cadenaUrl = (!devMode) ? urlBase.origin + '/PresupuestoPrivado.Api/' : 'https://localhost:7055/';
				break;
			case YeminusApis.PresupuestoPublico:
				cadenaUrl = (!devMode) ? urlBase.origin + '/PresupuestoPublico.Api/' : 'https://localhost:7127/';
				break;
			case YeminusApis.Produccion:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Produccion.Api/' : 'https://localhost:7252/';
				break;
			case YeminusApis.Salud:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Salud.Api/' : 'https://localhost:7130/';
				break;
			case YeminusApis.Security:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Security.Api/' : 'https://localhost:7180/';
				break;
			case YeminusApis.SolicitudesCompraMRP:
				cadenaUrl = (!devMode) ? urlBase.origin + '/SolicitudesCompraMRP.Api/' : 'https://localhost:7108/';
				break;
			case YeminusApis.TablasSistema:
				cadenaUrl = (!devMode) ? urlBase.origin + '/TablasSistema.Api/' : 'https://localhost:7026/';
				break;
			case YeminusApis.Ventas:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Ventas.Api/' : 'https://localhost:7257/';
				break;
			case YeminusApis.WebComponents:
				cadenaUrl = (!devMode) ? urlBase.origin + '/WebComponents/' : 'https://localhost:5001/';
				break;
			case YeminusApis.Ventas:
				cadenaUrl = (!devMode) ? urlBase.origin + '/Ventas.Api' : 'https://localhost:7257/';
				break;
			default:
				cadenaUrl = urlBase.href;
				break;
		}
	} catch (error) {
		console.log('Error al obtener la base url', error, `${this.obtenerBaseUrl.name}`);
	}
	return cadenaUrl;

}

export function ObtenerRaizUrl(baseUrl: string): HTMLAnchorElement {
	var urlBase = document.createElement('a');
	urlBase.href = baseUrl;
	return urlBase;
}

export function GuardarVariableDeSesion(llave: string, valor: string) {
	sessionStorage.setItem(llave, valor);
}

export function EliminarVariableDeSesion(llave: string) {
	sessionStorage.removeItem(llave);
}

export function ObtenerVariableDeSesion<T>(llave: string): T {
	let valorRetornar: T = null;
	try {
		const valor = sessionStorage.getItem(llave);
		const valorTipado = JSON.parse(valor);
		valorRetornar = valorTipado as T;
	} catch (error) {
		console.log(error);
	}
	return valorRetornar
}
/**
 * @param mensaje @deprecated
 */
export function cambiarMensajeModal(mensaje: string) {
	$('#waittingModalText').html(mensaje);
}


/**
 * Función que se encarga de obtener los parámetros de la url en petición get si da la casualidad de que
 * no funcione utilizando URLSearchParams
 * @param name 
 * @author Bvelez
 * @returns 
 * @deprecated
 */
export function getParameterByName(name) {
	// Se reemplazan carácteres '[',']'
	name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
	// Se utiliza expresión regular para separar el identificador y obtener su valor
	var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
		// Se le envía la url actual
		results = regex.exec(location.href);
	// Si está correcto decodifica la url y envía 
	return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

/**
 * Crea una excepción controlada por el usuario
 * @param {string} message El mensaje que muestra en consola si se envía en blanco no se muestra
 * @param {object} jsException La excepción generada por javascript
 * @param {string} origin Debería ser el nombre del controlador y el método dónde se genera la excepción
 * @returns {UserException}
 */
export function UserException(message: string = '', jsException, origin) {
	const obj = {
		message: message,
		name: 'UserException',
		exception: jsException,
		origin: origin
	};

	if (message !== '') {
		MensajeError(message);
	}

	console.log(obj);
}

/**
 * recibe los minutos y devuelve el tiempo en horas y minutos exactos (no tiene en cuenta si el numero de horas supera el dia "24 horas")
 * 
 * @author dcardenas
 */
export function sumarTiempo(minutosRecibidos: number) {
	let horas = 0;
	let minutos = 0;
	minutos += minutosRecibidos % 60;
	horas += Math.trunc(minutosRecibidos / 60);

	return { horas: horas, minutos: minutos };
}

/**
 * tomo el objeto de la enumeración y lo convierte en un array de objetos
 * Verdadero
 * @param data enumeración
 * @param enumString declara si la enumeracion es string o no
 * Modificado->Lsalazar
 * Se agrega de Utils
 */
export function enumToArray(data: any, trad?: TranslateService, enumString: boolean = false, omitirRegistrosSinDescripcion: boolean = false): { id: any, descripcion: string }[] {
	// SE DEBE DEJAR EL id como any dado que algunos id son string y otros number
	const map: { id: any; descripcion: string }[] = [];
	let desc: string;
	try {

		for (const n in data) {
			if (typeof data[n] === 'number' || (enumString ? n.indexOf('Descripcion') : false)) {
				desc = data['Descripcion' + n];
				if ((isDefinedAndNotEmpty(desc) && omitirRegistrosSinDescripcion === true) || omitirRegistrosSinDescripcion !== true) {
					if (!desc) {
						desc = n;
					}
					if (trad) {
						desc = trad.instant(desc);
					}
					map.push({ id: data[n], descripcion: desc });
				}
			}
		}
	} catch (error) {
		UserException('Error al convertir la enumeración en un array', error, `util.ts => ${enumToArray.name}`);
	}
	return map;
}

/**
 * Comprueba si al propiedad o variable se encuentra definida y contiene datos
 * @param pVar propiedad o variable
 * @author JHincapie
 * Modificado->Lsalazar
 * Se agrega de Utils
 */
export function isDefinedAndNotEmpty(pVar: any) {
	return isDefined(pVar) && !isNullOrEmpty(pVar);
}

/**
 * Comprueba si al propiedad o variable se encuentra definida
 * @param pVar propiedad o variable
 * Modificado->Lsalazar
 * Se agrega de Utils
 */
export function isDefined(pVar: any) {
	return typeof pVar !== 'undefined';
}

/**
 * Comprueba si al propiedad o variable contiene datos
 * @param pStringVar propiedad o variable
 * Modificado->Lsalazar
 * Se agrega de Utils
 */
export function isNullOrEmpty(pStringVar: any) {

	let isNull = false;
	if (pStringVar === null) {
		isNull = true;
	} else if (pStringVar === '') {
		isNull = true;
	} else if (pStringVar.length === 0) {
		isNull = true;
	} else if (pStringVar.length <= 0) {
		isNull = true;
	}

	return isNull;
}

/** Retorna la descripción del mes de acuerdo al número del mes
 * Devuelve el string en formato llave del archivo de lenguajes
 * @param month Numero de mes
 */
export function obtenerDescripcionMes(month: number = 0): string {

	let description = '';

	try {
		if (month > 0) {

			switch (month) {
				case 1:
					description = 'MONTH_1';
					break;
				case 2:
					description = 'MONTH_2';
					break;
				case 3:
					description = 'MONTH_3';
					break;
				case 4:
					description = 'MONTH_4';
					break;
				case 5:
					description = 'MONTH_5';
					break;
				case 6:
					description = 'MONTH_6';
					break;
				case 7:
					description = 'MONTH_7';
					break;
				case 8:
					description = 'MONTH_8';
					break;
				case 9:
					description = 'MONTH_9';
					break;
				case 10:
					description = 'MONTH_10';
					break;
				case 11:
					description = 'MONTH_11';
					break;
				case 12:
					description = 'MONTH_12';
					break;
				case 13:
					description = 'LBL_CLOSURE_PERIOD';
					break;
			}
		}
	} catch (error) {
		UserException(`Error al obtener la descripcion del mes con el numero ${month}`, error, `${obtenerDescripcionMes}`);
	}
	return description;
}

/**
 * retorna un arreglo con los meses (equivalente en numero y nombre )
 * @returns 
 */
export function obtenerMeses(): { numero: number; descripcion: string; }[] {

	let meses: Array<{ numero: number, descripcion: string }> = [];

	try {
		meses = [
			{ numero: 1, descripcion: 'Enero' },
			{ numero: 2, descripcion: 'Febrero' },
			{ numero: 3, descripcion: 'Marzo' },
			{ numero: 4, descripcion: 'Abril' },
			{ numero: 5, descripcion: 'Mayo' },
			{ numero: 6, descripcion: 'Junio' },
			{ numero: 7, descripcion: 'Julio' },
			{ numero: 8, descripcion: 'Agosto' },
			{ numero: 9, descripcion: 'Septiembre' },
			{ numero: 10, descripcion: 'Octubre' },
			{ numero: 11, descripcion: 'Noviembre' },
			{ numero: 12, descripcion: 'Diciembre' }
		];
	} catch (error) {
		UserException('Error al retornar el listado de los meses', error, `${obtenerMeses}`);
	}
	return meses;
}

/**
 * Este método permite eliminar todas las propiedades de un objeto o solamente eliminar las propiedades que estén null o undefined
 * @param objeto Este debe ser un objeto simple, no puede ser un array o un valor, debe ser objeto
 * @param eliminarSoloPropiedadesVacias si se envía en true elimina solo las propiedades que estén null o undefined, es muy útil a la hora de enviar datos al back
 * @author Sramirez
 */
export function eliminarPropiedadesObjeto(objeto: any, eliminarSoloPropiedadesVacias: boolean = false) {
	try {
		for (const propName in objeto) {
			if (objeto[propName] === null || objeto[propName] === undefined || eliminarSoloPropiedadesVacias !== true) {
				delete objeto[propName];
			} else {
				if (isDefinedAndNotEmpty(objeto[propName]) && typeof objeto[propName] === 'object') {
					eliminarPropiedadesObjeto(objeto[propName], true)
				}
			}
		}
	} catch (error) {
		UserException('Error al eliminar las propiedades del objeto', error, `util.ts => ${eliminarPropiedadesObjeto.name}`);
	}
}

/**
 * Muestra el modal "Esperando" y le adiciona un texto
 * @param {string} mensaje El texto que muestra en el modal esperando
 * @param {string} accion La acción a ajecutar, 1 para abrir, 0 o null para cerrar
 */
export function abrirModalCargando(mensaje = 'Cargando ...') {
	$('.loaderBox').show();
	$('#waittingModalText').html(mensaje);
}

/**
 * Muestra el modal "Esperando" y le adiciona un texto
 * @param {string} mensaje El texto que muestra en el modal esperando
 * @param {string} accion La acción a ajecutar, 1 para abrir, 0 o null para cerrar
 */
export function cerrarModalCargando() {
	$('.loaderBox').delay(500).fadeOut('slow');
	$('#waittingModalText').text('');
}
/**
	 * recibe la lista de errores, los traduce de ser necesario y los concatena devolviendo un string con todos ellos
	 * @author Sramirez
	 */
export function concatenarListaErrores(listaErrores: Array<string> = [], traduccion: TranslateService | undefined): string {
	let stringErrores = '';
	try {

		if (isDefinedAndNotEmpty(listaErrores) && listaErrores.length > 0) {
			listaErrores?.forEach(error => {
				const splitError = isDefinedAndNotEmpty(error) ? error.split(';') : null;
				if (isDefinedAndNotEmpty(splitError) && splitError && splitError?.length > 0) {
					// se añade una , para separar cada mensaje de error
					stringErrores += isDefinedAndNotEmpty(stringErrores) ? ', ' : '';
					splitError?.forEach(posicionError => {
						if (isDefinedAndNotEmpty(posicionError)) {
							// se añade un espacio para separar las palabras
							stringErrores += isDefinedAndNotEmpty(stringErrores) ? ' ' : '';
							if (isDefinedAndNotEmpty(traduccion)) {
								stringErrores += traduccion?.instant(posicionError);
							} else {
								stringErrores += posicionError;
							}
						}
					});
				}
			});
		}

	} catch (error) {
		UserException('', error, `util.ts => ${concatenarListaErrores.name}`);
	}
	return stringErrores;
}

/**
 * Devuelve true o false dependiendo de si la respuesta
 * del servidor es correcta, en caso de que la petición
 * no esté autorizada se retorna al login
 * @param response objeto respuesta del servidor
 * @param router servicio router del angular
 */
export function responseValidator(response: ResponseModel<any>, traduccion?: TranslateService): boolean {

	let toReturn = true;
	let tipoMensaje: string;
	let mensaje: string = '';
	let mensajeListaErrores: string = '';
	let continuar = true;

	try {

		if (!response.esExitoso) {
			toReturn = false;

			if (isDefinedAndNotEmpty(response.mensaje)) {
				mensaje = response.mensaje;
				tipoMensaje = 'advertencia';
				continuar = false;
			} else if (isDefinedAndNotEmpty(response.datos)) {
				if (typeof (response.datos) === 'string') {
					mensaje = response.datos;
					tipoMensaje = 'advertencia';
					continuar = false;
				} else if (isDefinedAndNotEmpty(response.datos.error) && typeof (response.datos.error) == 'string') {
					mensaje = response.datos.error;
					tipoMensaje = 'advertencia';
					continuar = false;
				}
			}
			if (isDefinedAndNotEmpty(mensaje) && typeof (mensaje) == 'string') {
				MensajeAdvertencia(traduccion ? traduccion.instant(mensaje) : mensaje);
			}

			if (isDefinedAndNotEmpty(response.infoOperacion)) {
				if (isDefinedAndNotEmpty(response.infoOperacion.excepcion)) {
					if (isDefinedAndNotEmpty(response.infoOperacion.excepcion.detalleErrorFiltrado)) {
						mensaje = response.infoOperacion.excepcion.detalleErrorFiltrado;
					} else {
						mensaje = response.infoOperacion.excepcion.detalleError;
					}
					if (isDefinedAndNotEmpty(mensaje)) {
						MensajeError(traduccion ? traduccion.instant(mensaje) : mensaje);
					}
				}
			}
			// el campo listaErrores puede venir tanto en el response como en el infooperacion, por jerarquía si el response.listaErrores ya tiene datos se omite el infooperacion
			const lengthErrores = response?.listaErrores?.length || 0;
			if (response && isDefinedAndNotEmpty(response.listaErrores) && lengthErrores > 0) {
				mensajeListaErrores = concatenarListaErrores(response?.listaErrores, traduccion);
				MensajeError(mensajeListaErrores);
			} else {
				if (isDefinedAndNotEmpty(response.infoOperacion) &&
					isDefinedAndNotEmpty(response.infoOperacion.listaErrores) &&
					response.infoOperacion.listaErrores.length > 0) {
					mensajeListaErrores = concatenarListaErrores(response.infoOperacion.listaErrores, traduccion);
					MensajeError(mensajeListaErrores);
				}
			}

			if (isDefinedAndNotEmpty(mensaje)) {
				console.clear();
				console.log(response.infoOperacion);
			}
			if (isDefinedAndNotEmpty(mensajeListaErrores)) {
				console.clear();
				console.log(response);
			}

		} else {
			if (isDefinedAndNotEmpty(response.infoOperacion?.mensajeAdvertencia)) {
				for (let mensaje of response.infoOperacion?.mensajeAdvertencia.split(';')) {
					if (isDefinedAndNotEmpty(mensaje)) {
						mensaje = (isDefinedAndNotEmpty(traduccion)) ? traduccion.instant(mensaje) : mensaje;
						MensajeAdvertencia(mensaje);
					}
				}
			}
		}
	} catch (error) {
		UserException(`Ocurrió un error al validar la respuesta del servidor`,
			error, `${responseValidator.name}`);
		toReturn = false;
	}
	return toReturn;
}
/**
 * Método que se encarga de devolver el numero de días, meses y años entre las dos fechas
 * @param fa 
 * @param fb 
 * @returns 
 */
export function diferenciafechas(fa: Date, fb: Date): { ans: number, meses: number, dias: number, Tdias: number } {  // fa y fb dos fechas

	fa = new Date(fa.toString());
	fb = new Date(fb.toString());
	let totdias = fa.getTime() - fb.getTime();
	totdias /= 3600000;
	totdias /= 24;
	totdias = Math.floor(totdias);
	totdias = Math.abs(totdias);

	let ans;
	let meses;
	let dias;
	let m2;
	let m1;
	let d3;
	let d2;
	let d1;
	let f2 = new Date();
	let f1 = new Date();

	if (fa > fb) { f2 = fa; f1 = fb; } else { f2 = fb; f1 = fa; }  // Siempre f2 > f1
	ans = f2.getFullYear() - f1.getFullYear(); // dif de años inicial
	m2 = f2.getMonth();
	m1 = f1.getMonth();
	meses = m2 - m1; if (meses < 0) { meses += 12; --ans; }

	d2 = f2.getDate();
	d1 = f1.getDate();
	dias = d2 - d1;

	let f3 = new Date(f2.getFullYear(), m2, 1);
	f3.setDate(f3.getDate() - 1);
	d3 = f3.getDate();

	if (d1 > d2) {
		dias += d3; --meses; if (meses < 0) { meses += 12; --ans; }
		if (fa > fb) {  // corrección por febrero y meses de 30 días
			f3 = new Date(f1.getFullYear(), m1 + 1, 1);
			f3.setDate(f3.getDate() - 1);
			d3 = f3.getDate();
			if (d3 === 30) {
				dias -= 1;
			}
			if (d3 === 29) {
				dias -= 2;
			}
			if (d3 === 28) {
				dias -= 3;
			}
		}
	}
	return { ans, meses, dias, Tdias: totdias };
}

/**
 * permite convertir 'S' o 'N' a un boolean para mapearlo a un switch
 * @author Jcastillo
 */
export function mapearAFormularioValorSwitch(valor: string) {
	try {
		let resultado = false;
		if (isDefinedAndNotEmpty(valor)) {
			switch (valor) {
				case SiyNoString.Si:
					resultado = true;
					break;
				case SiyNoString.No:
					resultado = false;
					break;
			}
		}
		return resultado;
	} catch (error) {
		UserException('Error al retornar el valor a mapear', error, `${mapearAFormularioValorSwitch.name}`);
	}
}

/**
 * obtiene la descripción de una enumeración siempre y cuando
 * esta se halla construido con la descripción
 * @param enumeracion La enumeración
 * @param llave la llave de la enumeración
 */
export function getEnumDescription(enumeracion: any, llave: number, trad?: TranslateService): string {
	let descripcionEnum: string;
	if (trad) {
		descripcionEnum = trad.instant(enumeracion['Descripcion' + enumeracion[llave].toString()]);
	} else {
		descripcionEnum = enumeracion['Descripcion' + enumeracion[llave].toString()];
	}
	return descripcionEnum;
}

/**
* Calcula el tiempo en modo de Día, mes y año
* @param {any} cantidadMinutos
* @returns
*/
export function calcularTiempo(cantidadMinutos: number, horasDelDia = 8): {
	minutos: number,
	horas: number,
	dias: number,
	meses: number,
	años: number,
	descripcion: string
} {
	try {
		const objTiempo = {
			minutos: 0,
			horas: 0,
			dias: 0,
			meses: 0,
			años: 0,
			descripcion: ''
		};

		if (!cantidadMinutos) {
			cantidadMinutos = 0;
		}

		if (cantidadMinutos) {
			if (horasDelDia === undefined) {
				horasDelDia = 8;
			}

			objTiempo.minutos = Math.round(cantidadMinutos % 60);
			objTiempo.horas = Math.round(((cantidadMinutos - objTiempo.minutos) / 60) % horasDelDia);
			objTiempo.dias = Math.round((cantidadMinutos - objTiempo.minutos - (objTiempo.horas * 60)) / (horasDelDia * 60));
			objTiempo.meses = Math.round(objTiempo.dias / 30.417);
			objTiempo.años = Math.round(objTiempo.años / 24);
			const dias = objTiempo.dias !== 0 ? objTiempo.dias + 'd' : '';
			const horas = objTiempo.horas !== 0 ? objTiempo.horas + 'h' : '';
			const minutos = objTiempo.minutos !== 0 ? objTiempo.minutos + 'min' : '';
			const shoras = (horas !== '' ? (dias !== '' ? ', ' + horas : horas) : '');
			const sminutos = (minutos !== '' ? (shoras !== '' ? ', ' + minutos : minutos) : '');
			objTiempo.descripcion = (dias + shoras + sminutos).trim();

			if (!objTiempo.descripcion) {
				objTiempo.descripcion = '0m';
			}
		} else {
			objTiempo.descripcion = '0m';
		}

		return objTiempo;
	} catch (e) {
		console.log(e);
	}
}

/**
 * Obtiene los minutos de un arreglo del formato Días, Horas y Minutos
 * @param {any} tiempo
 */
export function obtenerMinutos(tiempo: any, usar24Horas = '') {
	try {
		let horasJornada = 8;
		if (isDefinedAndNotEmpty(usar24Horas)) {
			horasJornada = 24;
		}
		return (isDefinedAndNotEmpty(tiempo.dias) ? tiempo.dias * horasJornada * 60 : 0) +
			(isDefinedAndNotEmpty(tiempo.horas) ? tiempo.horas * 60 : 0) +
			(isDefinedAndNotEmpty(tiempo.minutos) ? tiempo.minutos : 0);

	} catch (e) {
		console.log(e);
	}
}

/**
 * Comprueba si al propiedad o variable se encuentra definida y contiene datos
 * @param propiedad propiedad o variable
 * @author JHincapie
*/
export function isDefinedAndNotEmptyObjects(propiedad: any, nombresPropiedades: Array<string>, nuevoObjeto?: any) {
	nuevoObjeto = { ...propiedad };
	if (isDefinedAndNotEmpty(nuevoObjeto)) {
		if (nombresPropiedades.length > 0) {
			for (const obj of nombresPropiedades) {
				if (isDefinedAndNotEmpty(nuevoObjeto[obj])) {
					nuevoObjeto = nuevoObjeto[obj];
				} else {
					return false;
				}
			}
		}
	}
	return true;
}

/**
 * Se calcula el dígito de verificación de la dian
 * @param nit
 * @author Ymonsalve
 * @author Bvelez -> Se asigna a librería Utils 04/08/2022
 */
export function calcularDigitoVerificacion(nit: number) {
	try {
		// tslint:disable-next-line: one-variable-per-declaration
		let constantesMultiplicacion, acumulado, digito, cantidadCaracteresNit;
		// Se valida si el nit es valido
		if (isNaN(nit)) {
			console.log('El nit/cédula "' + nit + '" no es válido(a).');
			return '';
		}

		constantesMultiplicacion = new Array(16);
		/// Se toma la cantidad de caracteres que tiene el parametro nit
		cantidadCaracteresNit = nit.toString().length;

		/// Se guarda en cada posición del constantesMultiplicacion una constante diferente
		constantesMultiplicacion[1] = 3;
		constantesMultiplicacion[2] = 7;
		constantesMultiplicacion[3] = 13;
		constantesMultiplicacion[4] = 17;
		constantesMultiplicacion[5] = 19;
		constantesMultiplicacion[6] = 23;
		constantesMultiplicacion[7] = 29;
		constantesMultiplicacion[8] = 37;
		constantesMultiplicacion[9] = 41;
		constantesMultiplicacion[10] = 43;
		constantesMultiplicacion[11] = 47;
		constantesMultiplicacion[12] = 53;
		constantesMultiplicacion[13] = 59;
		constantesMultiplicacion[14] = 67;
		constantesMultiplicacion[15] = 71;

		acumulado = 0;
		digito = 0;
		for (let i = 0; i < cantidadCaracteresNit; i++) {
			/// Cada que el ciclo recorre, se toma un caracter del parametro nit
			digito = parseInt(nit.toString().substr(i, 1));
			acumulado += (digito * constantesMultiplicacion[cantidadCaracteresNit - i]);
		}
		digito = acumulado % 11;

		return (digito > 1) ? 11 - digito : digito;
	} catch (error) {
		UserException('Error al intentar calcular el dígito de verificación', error, `util.ts => ${this.calcularDigitoVerificacion.name}`);
	}

}

/**
 * realiza un distinc de un arreglo recibido por parametro segun la llave recubida por parametro
 * @param arreglo arreglo del cual se va a realizar el distinct 
 * @param llave llave por la cual se va a realizar el distinct el cual distinct
 * @returns 
 */
export function distinct(arreglo: any, llave: string) {
	return [...new Map(arreglo.map(item => [item[llave], item])).values()];
}

/**
 * Aproxima al 100 mas cercano
 * @param valor
 * @author JRuiz
 */
export function redondearAPeso(valor: number) {
	return (Math.round(Math.round(valor) / 100) * 100);
}

export function obtenerEstructuraFormatoMoneda(moneda: string) {
	let formato = '#,##0.##';

	switch (moneda) {
		case Monedas.PesoColombiano:
			formato = '$ #,##0.00';
			break;
		case Monedas.Dolar:
			formato = '$ ' + formato;
			break;
		case Monedas.Euro:
			formato = '€ ' + formato;
			break;
		case Monedas.Yuan:
			formato = '¥ ' + formato;
			break;
		case Monedas.LibraEsterlina:
			formato = '£ #,##0,##' + formato;
			break;
		case Monedas.Real:
			formato = 'R$ ' + formato;
			break;
		case Monedas.Yen:
			formato = '¥ #,##0' + formato;
			break;
		case Monedas.PesoMexicano:
			formato = '$ ' + formato;
			break;
		default:
			break;
	}

	return formato;
}

/**
 * Las fecha deben estan en el formato de fechas de javascript => Ej: Thu Mar 09 2017 09:05:06 GMT-0500 (Hora est. Pacífico, Sudamérica)
 * @param interval ms => milisegundos, ss => segundos, mi => minutos, hh => horas, dd => dias, yy => años
 * @param fraccion indica si mostrar tiempo en fraccion o redondeado
 */
export function dateDiff(interval: string, initialDate: Date, finalDate: Date, fraccion?: boolean) {
	initialDate = new Date(initialDate);
	finalDate = new Date(finalDate);
	let diff: number;
	let ms: number;
	ms = 1;
	let ss: number;
	ss = 1000 * ms;
	let mi: number;
	mi = 60 * ss;
	let hh: number;
	hh = 60 * mi;
	let dd: number;
	dd = 24 * hh;
	let yy: number;
	yy = 365 * dd;

	if (interval === 'ms') {
		return diff = finalDate.getTime() - initialDate.getTime();
	}

	if (fraccion) {
		switch (interval) {
			case 'yy':
				diff = diff / yy;
				break;

			case 'dd':
				diff = diff / dd;
				break;

			case 'hh':
				diff = diff / hh;
				break;

			case 'mi':
				diff = diff / mi;
				break;

			case 'ss':
				diff = diff / ms;
				break;
		}

	} else {

		let fechaI: number;
		let fechaF: number;
		switch (interval) {
			case 'yy':
				diff = Math.trunc((finalDate.getTime() - initialDate.getTime()) / yy);
				break;

			case 'dd':
				fechaI = new Date(initialDate.getTime() - (initialDate.getHours() * hh + initialDate.getMinutes() *
					mi + initialDate.getSeconds() * ss + initialDate.getMilliseconds())).getTime();

				fechaF = new Date(finalDate.getTime() - (finalDate.getHours() * hh + finalDate.getMinutes() *
					mi + finalDate.getSeconds() * ss + finalDate.getMilliseconds())).getTime();

				diff = (fechaF - fechaI) / dd;
				break;

			case 'hh':
				fechaI = new Date(initialDate.getTime() - (initialDate.getMinutes() * mi + initialDate.getSeconds() *
					ss + initialDate.getMilliseconds())).getTime();

				fechaF = new Date(finalDate.getTime() - (finalDate.getMinutes() * mi + finalDate.getSeconds() *
					ss + finalDate.getMilliseconds())).getTime();

				diff = (fechaF - fechaI) / hh;
				break;

			case 'mi':
				fechaI = new Date(initialDate.getTime() - (initialDate.getSeconds() * ss + initialDate.getMilliseconds())).getTime();
				fechaF = new Date(finalDate.getTime() - (finalDate.getSeconds() * ss + finalDate.getMilliseconds())).getTime();
				diff = (fechaF - fechaI) / mi;
				break;

			case 'ss':
				fechaI = new Date(initialDate.getTime() - initialDate.getMilliseconds()).getTime();
				fechaF = new Date(finalDate.getTime() - finalDate.getMilliseconds()).getTime();
				diff = (fechaF - fechaI) / ss;
		}
	}
	return diff;
}

export function sumarDiasFecha(pDays: number, pDate: Date) {
	const fecha = new Date(pDate);
	// Obtenemos los milisegundos de la fecha
	const tiempo = fecha.getTime();
	// Calculamos los milisegundos sobre la fecha que hay que sumar o restar...
	const milisegundos = pDays * 24 * 60 * 60 * 1000;
	return fecha.setTime(tiempo + milisegundos);
}
/**
	 * Se carga etiqueta link con el link a archivo css
	 * @param url string
	 */
export function cargarHojaDeEstilos(url: string, documentTmp: Document = null) {

	const node = document.createElement('link');
	node.href = url;
	node.rel = 'stylesheet';
	documentTmp = !!documentTmp ? documentTmp : document;
	documentTmp.getElementsByTagName('head')[0].appendChild(node);

}

export function cargarScript(url: string) {

	const node = document.createElement('script');
	node.src = url;
	node.type = 'text/javascript';
	node.async = false;
	document.getElementsByTagName('body')[0].appendChild(node);
}

export function calcularTiempoHorasMinutos(cantidadMinutos: number, horasDelDia?: number) {
	try {
		const objTiempo = {
			minutos: 0,
			horas: 0,
			descripcion: ''
		};

		if (!cantidadMinutos) {
			cantidadMinutos = 0;
		}

		if (cantidadMinutos) {
			if (horasDelDia === undefined) {
				horasDelDia = 8;
			}

			objTiempo.minutos = cantidadMinutos % 60;
			objTiempo.horas = ((cantidadMinutos - objTiempo.minutos) / 60);

			const minutos = objTiempo.minutos !== 0 ? objTiempo.minutos + 'm' : '';
			const horas = objTiempo.horas !== 0 ? objTiempo.horas + 'h' : '';
			const sminutos = (minutos !== '' ? (horas !== '' ? ', ' + minutos : minutos) : '');

			objTiempo.descripcion = (horas + sminutos).trim();

			if (!objTiempo.descripcion) {
				objTiempo.descripcion = '0m';
			}
		} else {
			objTiempo.descripcion = '0m';
		}

		return objTiempo;

	} catch (e) {
		console.log(e);
	}
}

/**
 * @param array Array que se requiere agrupar
 * @param fnPropiedad Función que retorna la propiedad por la cual se agrupará el arreglo
 * @returns Array agrupado por la propiedad
 * @param K Tipo de dato de la propiedad por la cual se agrupará el arreglo
 * @param V Tipo de modelo del detalle del arreglo
 * @author David Balanta
 */
export function agruparArrayPorPropiedad<T, K extends string | number | symbol, V>(array: T[], fnPropiedad: (item: T) => K): ClaveValorModel<K, T[]>[] {
	if (isDefinedAndNotEmpty(array) && isDefinedAndNotEmpty(fnPropiedad)) {
		const groupedObj = array.reduce((prev, curr) => {
			const groupKey = fnPropiedad(curr);
			const group = prev[groupKey] || [];
			group.push(curr);
			return { ...prev, [groupKey]: group };
		}, {} as Record<K, T[]>);
		return Object.entries(groupedObj).map(([clave, valor]) => ({ clave, valor })) as ClaveValorModel<K, T[]>[];
	} else {
		return [];
	}
}

export function calcularTiempoSegundos(cantidadSegundos: number){
	cantidadSegundos = Math.round((cantidadSegundos + Number.EPSILON) * 100) / 100
	try	{
		const objTiempo = {
			segundos: 0,
			minutos: 0,
			horas: 0,
			dias: 0,
			meses: 0,
			años: 0,
			descripcion: ''
		};

		objTiempo.segundos = cantidadSegundos % 60;
		objTiempo.segundos = Math.round((objTiempo.segundos + Number.EPSILON) * 100) / 100
		if(cantidadSegundos / 60 > 1){
			const tiempoTotal = this.calcularTiempo(Math.round(cantidadSegundos / 60), 12);
			objTiempo.minutos = tiempoTotal?.minutos || 0;
			objTiempo.horas = tiempoTotal?.horas || 0;
			objTiempo.dias = tiempoTotal?.dias || 0;
			objTiempo.meses = tiempoTotal?.meses || 0;
			objTiempo.años = tiempoTotal?.años || 0;
			objTiempo.descripcion += tiempoTotal?.descripcion + ' ' + (objTiempo.segundos + 's').trim();
		} else {
			objTiempo.descripcion = (objTiempo.segundos + 's').trim();
		}

		return objTiempo;
	} catch(e){
		console.log(e);
	}
}

export function ObtenerMinutos(tiempo: any, usar24Horas = '') {
	try {
		let horasJornada = 8;
		if (isDefinedAndNotEmpty(usar24Horas)) {
			horasJornada = 24;
		}
		return (isDefinedAndNotEmpty(tiempo.dias) ? tiempo.dias * horasJornada * 60 : 0) + (isDefinedAndNotEmpty(tiempo.horas) ? tiempo.horas * 60 : 0) + (isDefinedAndNotEmpty(tiempo.minutos) ? tiempo.minutos : 0);

	} catch (e) {
		console.log(e);
	}
}

/**
 * Se calcula los años meeses y dias a partir de dos fechas
 * @param f1 fecha inicial
 * @param f2 fecha final
 * @returns object
 */
export function CalculaMesesAños(f1: Date, f2: Date) {

	const fechaIngreso = new Date(f1);
	const fechaRetiro = new Date(f2);
	const toReturn = { dias: 0, meses: 0, anios: 0 };

	let diferenciaMeses = fechaRetiro.getMonth() - fechaIngreso.getMonth();
	let meses = diferenciaMeses < 0 ? 12 + diferenciaMeses : diferenciaMeses;

	let anios = Math.round(fechaRetiro.getFullYear() - fechaIngreso.getFullYear());
	
	let dias = 0;
	if ((fechaRetiro.getMonth() - fechaIngreso.getMonth()) < 0 || ((fechaRetiro.getMonth() - fechaIngreso.getMonth()) === 0 && fechaRetiro.getDate() < fechaIngreso.getDate())) {
		anios--;
	}
	
	dias = fechaIngreso.getDate() - fechaRetiro.getDate();

	if (dias < 0) {
		dias = -(dias)
	} else if(dias > 0)
	{
		meses = (meses - 1 < 0) ? 11 : meses - 1;
		dias = (new Date(fechaRetiro.getFullYear(), fechaRetiro.getMonth() + 1, 0).getDate()) - dias;
	}

	toReturn.dias = dias;
	toReturn.meses = meses;
	toReturn.anios = anios;
	return toReturn;
}

class ClaveValorModel<K, V> {
	clave: K;
	valor: V;
}